import React from 'react';

export const GeorgiaInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">City of Atlanta</p>
        <p className="eds-l-mar-bot-1">
            <strong>Emergency Fund</strong> |&nbsp;
            <a
                href="https://www.atlantaga.gov/Home/Components/News/News/13298/672"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            This $7M emergency fund includes $1.5M to support small business
            continuity and $1.5M to assist hourly wage earners of businesses
            engaged with the City of Atlanta.
        </p>
    </div>
);
